import MIMISLOTActions from './MIMISLOTActions'

export default class MIMIEGAMEActions extends MIMISLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'MIMI-EGAME-001',
      platform: 'MIMI',
    }

    this.gameName = 'Mini Tree'
  }
}
